export class LatLon {
  public latitude: number
  public longitude: number

  constructor(latitude: number, longitude: number) {
    this.latitude = latitude
    this.longitude = longitude
  }

  public toString() {
    return this.latitude + ',' + this.longitude
  }
  public toStringReverse() {
    return this.longitude + ',' + this.latitude
  }
}
